export function getScriptSrc(cfg) {
  return "https://webapi.amap.com/maps?callback=__amap_init_callback" + "&v=".concat(cfg.AMap.version) + "&key=".concat(cfg.key) + "&plugin=".concat(cfg.AMap.plugins.join(','));
}